import React, { Component } from 'react';
import { Spin, Form, Input, Select, InputNumber, message, Button } from 'antd';
import axios from 'axios';
import {Parse} from 'parse';

import DaumPostcode from 'react-daum-postcode';
import { FormattedMessage, FormattedHTMLMessage, defineMessages ,   injectIntl } from 'react-intl';
import '../../../styles/Payouts.css';
import payoutRequest from '../../../utils/payoutRequest';
import _ from 'lodash';

const FormItem = Form.Item;
const Option = Select.Option;

const messages=defineMessages({
  nameRequired:{
    id:'PayoutsForm.form.name.error.required',
    defaultMessage:'Name is required'
  },
  emailRequired:{
    id:'PayoutsForm.form.email.error.required',
    defaultMessage:'Email is required'
  },
  emailType:{
    id:'PayoutsForm.form.email.error.type',
    defaultMessage:'Email is not a valid email'
  },
  accountBankRequired:{
    id:'PayoutsForm.form.accountBank',
    defaultMessage:"Please select a bank"
  },
  BankDefault:{
    id:'PayoutsForm.form.bankDefault',
    defaultMessage:"Bank"
  },
  accountNumber:{
    id:'PayoutsForm.form.accountNumber',
    defaultMessage:"Account number"
  },
  accountNumberRequired:{
    id:'PayoutsForm.form.accountNumber.error.required',
    defaultMessage:"Account number is required"
  },
  accountNumberType:{
    id:'PayoutsForm.form.accountNumber.error.type',
    defaultMessage:"Account number is not a valid Account Number"
  },
  accountName:{
    id:'PayoutsForm.form.accountName',
    defaultMessage:"A deposit"
  },
  accountNameRequired:{
    id:'PayoutsForm.form.accountName.error.required',
    defaultMessage:"A deposit is required"
  },
  registNumFront:{
    id:'PayoutsForm.form.registNumFront',
    defaultMessage:"YYMMDD"
  },
  registNumFrontRequired:{
    id:'PayoutsForm.form.registNumFront.error.required',
    defaultMessage:"Resident registration number is required"
  },
  registNumFrontType:{
    id:'PayoutsForm.form.registNumFront.error.type',
    defaultMessage:"Resident registration number is not valid number"
  },
  registNumBackRequired:{
    id:'PayoutsForm.form.registNumBack.error.required',
    defaultMessage:"Resident registration number is required"
  },
  registNumBackType:{
    id:'PayoutsForm.form.registNumBack.error.type',
    defaultMessage:"Resident registration number is not valid number"
  },
  zoneCodeRequired:{
    id:'PayoutsForm.form.zoneCode.error.required',
    defaultMessage:"Please search the address."
  },
  detailAddress:{
    id:'PayoutsForm.form.detailAddress',
    defaultMessage:"Remaining address"
  },
  paymentRequestRequired:{
    id:'PayoutsForm.form.payment.request.error.required',
    defaultMessage:"Payment amount is required"
  },
  paymentRequestType:{
    id:'PayoutsForm.form.payment.request.error.type',
    defaultMessage:"You can apply in dollar increments from the amount of more than $100."
  },
  notMatchEmail:{
    id:'PayoutsForm.form.payment.request.notMatchEmail',
    defaultMessage:"E-mail does not match the one you joined."
  },
  requestFailed:{
    id:'PayoutsForm.form.payment.request.failed',
    defaultMessage:"You have exceeded your credit. Please check it."
  },
  requestMailSuccess:{
    id:'PayoutsForm.form.payment.request.mail.success',
    defaultMessage:"Request Success"
  },
  requestMailError:{
    id:'PayoutsForm.form.payment.request.mail.error',
    defaultMessage:"Error! Please try again"
  },
});

const bankInfos = [
  {
    id: 'NH',
    value: '농협',
    defaultMessage : 'NH Bank'
  },
  {
    id: 'KB',
    value: '국민',
    defaultMessage : 'KB Bank'
  },
  {
    id: 'Shinhan',
    value: '신한',
    defaultMessage : 'Shinhan Bank'
  },
  {
    id: 'Woori',
    value: '우리',
    defaultMessage : 'Woori Bank'
  },
  {
    id: 'Hana',
    value: '하나',
    defaultMessage : 'KEB Hana Bank'
  },
  {
    id: 'IBK',
    value: 'IBK 기업',
    defaultMessage : 'IBK Bank'
  },
  {
    id: 'SC',
    value: 'SC제일은행',
    defaultMessage : 'Standard Charterd (SC)'
  },
  {
    id: 'Citi',
    value: '씨티',
    defaultMessage : 'Citi bank'
  },
  {
    id: 'KDB',
    value: 'KDB산업',
    defaultMessage : 'KDB Bank'
  },
  {
    id: 'ACU',
    value: '새마을',
    defaultMessage : 'Agricultural Cooperation Unit'
  },
  {
    id: 'Daegu',
    value: '대구',
    defaultMessage : 'Daegu Bank'
  },
  {
    id: 'Kwangju',
    value: '광주',
    defaultMessage : 'Kwangju Bank'
  },
  {
    id: 'KoreaPost',
    value: '우체국',
    defaultMessage : 'Korea Post Office'
  },
  {
    id: 'Shinhyup',
    value: '신협',
    defaultMessage : 'National Credit Union Federation of Korea'
  },
  {
    id: 'Jeonbuk',
    value: '전북',
    defaultMessage : 'Jeonbuk'
  },
  {
    id: 'Kyongnam',
    value: '경남',
    defaultMessage : 'Kyongnam Bank'
  },
  {
    id: 'Busan',
    value: '부산',
    defaultMessage : 'Busan Bank'
  },
  {
    id: 'Suhyup',
    value: '수협',
    defaultMessage : 'Suhyup Bank'
  },
  {
    id: 'Jeju',
    value: '제주',
    defaultMessage : 'Jeju Bank'
  },
  {
    id: 'Kakao',
    value: '카카오뱅크',
    defaultMessage : 'Kakao Bank'
  },
  {
    id: 'HSBC',
    value: 'HSBC',
    defaultMessage : 'HSBC'
  },
  {
    id: 'ICBC',
    value: '중궁공상',
    defaultMessage : 'ICBC'
  },
  {
    id: 'JP',
    value: 'JP모간',
    defaultMessage : 'JP Morgan'
  },
  {
    id: 'Deutsche',
    value: '도이치',
    defaultMessage : 'Deutsche Bank'
  },
  {
    id: 'BNP',
    value: 'BNP파리바',
    defaultMessage : 'BNP Paribas'
  },
  {
    id: 'BOA',
    value: 'BOA',
    defaultMessage : 'Bank of America'
  } 
]
class Korea extends Component{
  constructor(props){
    super(props);
    this.state={
      addressVisible: false,
      loading: false
    }
    this._handleRequest = this._handleRequest.bind(this);
    this._handleRequestDebounced= _.debounce(this._handleRequest, 1000);
  }

  componentWillUnmount() {
    this._handleRequestDebounced.cancel();
  }

  render() {
    const { getFieldDecorator, getFieldError} = this.props.form;
    const {formatMessage}=this.props.intl;
      return (
        <Spin spinning={this.state.loading}>
          <p className="headline payoutsform-headline">
            <FormattedMessage
              id="PayoutsForm.korean.headline"
              defaultMessage="Remittance Request (KOREA)"
            />
          </p>


          <Form className="payoutsform" layout="inline">
              <div className="payoutsform-content-box">
                <span className="payoutsform-input-label">
                  <FormattedMessage
                    id={'PayoutsForm.form.name'}
                    defaultMessage={'Name:'}/>
                </span>
                <FormItem validateStatus={getFieldError('name') ? 'error' : ''} style={{verticalAlign:'middle'}}>
                  {getFieldDecorator('name', {
                    rules: [
                      { required: true, message: formatMessage(messages.nameRequired) },
                    ],
                  })(
                      <Input style={{width:'224px', height:'32px'}}/>
                  )}
                </FormItem>
              </div>
              <div className="payoutsform-content-box">
                <span className="payoutsform-input-label">
                  <FormattedMessage
                    id={'PayoutsForm.form.email'}
                    defaultMessage={'E-mail:'}
                  />
                </span>
                <FormItem validateStatus={getFieldError('email') ? 'error' : ''} style={{verticalAlign:'middle'}}>
                  {getFieldDecorator('email', {
                    rules: [
                      {type:'email', message: formatMessage(messages.emailType) },
                      { required: true, message: formatMessage(messages.emailRequired) },
                    ],

                  })(
                    <div>
                      <Input style={{width:'224px', height:'32px'}} />
                      <span className="payoutsform-explain" style={{margin:'auto 9px'}}>
                        <FormattedMessage
                          id={'PayoutsForm.form.email.explain'}
                          defaultMessage={'* Enter subscribed E-mail'}
                        />
                      </span>
                    </div>
                  )}
                </FormItem>
              </div>
              <div className="payoutsform-content-box payoutsform-content-outer">
                <div className="payoutsform-input-label payoutsform-content-title">
                  <FormattedMessage
                    id={'PayoutsForm.form.account'}
                    defaultMessage={'Account:'}
                  />
                </div>
                <div className="payoutsform-content-inner">
                  <FormItem validateStatus={getFieldError('accountBank') ? 'error' : ''} style={{verticalAlign:'middle'}}>
                    {getFieldDecorator('accountBank', {
                      rules: [
                        { required: true, message: formatMessage(messages.accountBankRequired) },
                      ],
                    })(
                        <Select placeholder={formatMessage(messages.BankDefault)}  style={{ width:'200px' }}>
                          {
                            bankInfos.map(bankInfo => 
                              <Option value={bankInfo.value} key={bankInfo.id}>
                                <FormattedMessage
                                  id={`PayoutsForm.korean.form.account.bank.${bankInfo.id}`}
                                  defaultMessage={bankInfo.defaultMessage}
                                />
                              </Option>
                            )
                          }
                        </Select>
                    )}
                  </FormItem>

                  <FormItem validateStatus={getFieldError('accountNumber') ? 'error' : ''}>
                    {getFieldDecorator('accountNumber', {
                      rules: [
                        { required: true, message: formatMessage(messages.accountNumberRequired) },
                        { pattern: /[0-9]-?/, message: formatMessage(messages.accountNumberType) },
                      ],

                    })(
                        <Input placeholder={formatMessage(messages.accountNumber)} style={{width:'224px', height:'32px'}} />
                    )}
                  </FormItem>

                  <FormItem validateStatus={getFieldError('accountName') ? 'error' : ''}>
                    {getFieldDecorator('accountName', {
                      rules: [
                        { required: true, message: formatMessage(messages.accountNameRequired) },
                      ],
                      
                    })(
                      <Input placeholder={formatMessage(messages.accountName)} style={{width:'224px', height:'32px'}} />
                      )}
                  </FormItem>
                </div>
                </div>
              <div className="payoutsform-content-box">
                <span className="payoutsform-input-label">
                  <FormattedMessage
                    id={'PayoutsForm.form.registNumber'}
                    defaultMessage={'Resident registration number :'}
                  />
                </span>

                  <FormItem validateStatus={getFieldError('registNumFront') ? 'error' : ''} style={{verticalAlign:'middle'}}>
                    {getFieldDecorator('registNumFront', {
                      rules: [
                        { required: true, message: formatMessage(messages.registNumFrontRequired) },
                        { pattern: /^(?:[0-9]{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[1,2][0-9]|3[0,1]))$/, message: formatMessage(messages.registNumFrontType) }
                      ],

                    })(
                      <div style={{display: 'flex', alignItems: 'center'}}>

                        <Input placeholder={formatMessage(messages.registNumFront)} style={{width:'88px', height:'32px',marginRight:'15px'}} />
                        -
                      </div>
                    )}
                  </FormItem>


                  <FormItem validateStatus={getFieldError('registNumBack') ? 'error' : ''} style={{verticalAlign:'middle'}}>

                    {getFieldDecorator('registNumBack', {
                      rules: [
                        { required: true, message: formatMessage(messages.registNumBackRequired) },
                        { pattern: /^[1-4][0-9]{6}$/, message: formatMessage(messages.registNumBackType) }
                      ],

                    })(
                      <span>
                        <Input style={{width:'88px', height:'32px'}} />
                      </span>
                    )}
                  </FormItem>
                <span className="payoutsform-explain">
                  <FormattedMessage
                    id={'PayoutsForm.form.registNumber.explain'}
                    defaultMessage={'* You must enter the resident registration number of the account holder.'}
                  />
                </span>
              </div> 
              <div className="payoutsform-content-box payoutsform-content-outer">
                <div className="payoutsform-input-label payoutsform-content-title">
                  <FormattedMessage
                    id={'PayoutsForm.form.address'}
                    defaultMessage={'Address :'}
                  />
                </div>
                <div className="payoutsform-content-inner">
                  <FormItem validateStatus={getFieldError('zoneCode')? 'error' : ''} style={{verticalAlign:'middle'}}>
                    <div style={{display:'flex', alignItems:'center', marginBottom:3}}>
                      {
                        getFieldDecorator('zoneCode', {})(<Input style={{width:'104px', height:'32px',marginRight:'4px'}}/>)
                      }
                      <button type="button" onClick={this.handleVisibleChange} className="payoutsform-zonecode-btn">
                        <FormattedMessage
                          id={'PayoutsForm.form.zoneCode.btn'}
                          defaultMessage={'Seach for Postal Code'}
                        />
                      </button>
                    </div>
                    <DaumPostcode
                      onComplete={this.handleAddress}
                      animation={true} width="40%"
                      style={this.state.addressVisible? {} :{display: "none"}}/>

                  </FormItem>

                  <FormItem validateStatus={getFieldError('searchAddress') ? 'error' : ''}>
                    {getFieldDecorator('searchAddress', {
                      rules: [
                        { required:true, message: formatMessage(messages.zoneCodeRequired) },
                      ],
                    })(
                        <Input style={{width:'353px', height:'32px'}} />
                    )}
                  </FormItem>

                  <FormItem validateStatus={getFieldError('detailAddress') ? 'error' : ''}>
                    {getFieldDecorator('detailAddress')(
                      <Input placeholder={formatMessage(messages.detailAddress)}style={{width:'353px', height:'32px'}} />
                    )}
                  </FormItem>
                  </div>
                </div>

              <div className="payoutsform-content-box">
                <span className="payoutsform-input-label">
                  <FormattedMessage
                    id={'PayoutsForm.form.payment.amount.request'}
                    defaultMessage={'Payment amount request ($) :'}
                  />
                </span>

                <FormItem validateStatus={getFieldError('paymentRequest') ? 'error' : ''} style={{verticalAlign:'middle'}}>
                  {getFieldDecorator('paymentRequest', {
                    rules: [
                      { required: true, message: formatMessage(messages.paymentRequestRequired) },
                      { pattern:/^[0-9]*$/, message:formatMessage(messages.paymentRequestType) },
                    ],

                  })(
                    <InputNumber max={this.props.credit} placeholder="100" style={{width:'95px', height:'32px'}}/>
                  )}
                </FormItem>
                <span className="payoutsform-current-credit">
                <FormattedHTMLMessage
                  id="PayoutsForm.form.payment.credit"
                  defaultMessage="Remittable Revenue : "
                />
                {this.props.credit}($)
                </span>
              </div>
              <Button className="payouts-request-btn" type="primary" onClick={()=> this.setState({loading: true}, this._handleRequestDebounced)}>
                <FormattedMessage
                  id={'PayoutsForm.request.btn'}
                  defaultMessage={'Filing for'}
                />
              </Button>

            </Form>
        </Spin>
      )
    }



    handleVisibleChange =()=>{
      if (this.state.addressVisible===false){
        this.setState({
          addressVisible : true
        });
      }else{
        this.setState({
          addressVisible : false
        });
      }

    }

    handleAddress=(data)=>{
      console.log('handleAddress');
      this.setState({
        addressVisible:false
      });
      this.props.form.setFieldsValue({
       searchAddress: data.address||data.autoRo,
       zoneCode:data.zonecode,
     });

  }

  _handleRequest(){

    this.props.form.validateFields(async(err, values) => {
      // 세부 주소를 입력 안했을 시 메일 전송에서 undefined 안뜨게 하기
      if(values.detailAddress===undefined||values.detailAddress===null)
        values.detailAddress='';
      // mail로 보낼 데이터 formData에 넣어주기
      let formData = new FormData();

      formData.append('userId', Parse.User.current().id);
      formData.append('sessionToken', Parse.User.current().getSessionToken());
      formData.append('신청 방법', 'korea');
      formData.append('email', values.email);
      formData.append('이름', values.name);
      formData.append('은행', values.accountBank);
      formData.append('계좌번호', values.accountNumber);
      formData.append('주민등록번호', values.registNumFront+'-'+values.registNumBack);
      formData.append('주소', values.zoneCode+'(우편번호) '+values.searchAddress+' '+values.detailAddress);
      formData.append('신청금액', values.paymentRequest);

      const userInfo={
        'name': values.name,
        'email': values.email,
        'accountBank': values.accountBank,
        'accountName': values.accountName,
        'zoneCode': values.zoneCode,
        'address': values.searchAddress+' '+values.detailAddress,
        'paymentRequest': values.paymentRequest
      }; //userInfo object

      const {formatMessage}=this.props.intl;
      const{onCancel}=this.props;
      if(!err){//form 형식에서 에러 안날 시
        //1. 입력한 이메일이 로그인한 유저의 이메일과 같은지 비교하기
        if(values.email !== Parse.User.current().getEmail()){
          message.error(formatMessage(messages.notMatchEmail));
          return;
        }

        //2. 같을 경우 money, payout class에 추가 요청하는 함수 호출
        const payoutRequestResult = await payoutRequest(values.paymentRequest, userInfo,"korea");
        if(payoutRequestResult===false) {
          message.error(formatMessage(messages.requestFailed));
          this.setState({loading: false});
          onCancel();
        }
        else{
         //payout_manager에게 정산 요청 메일 발송.
          axios.post(process.env.REACT_APP_REQUEST_PAYMENT, formData)
          .then((res)=>{
            this.setState({loading : false}, () => {
              message.success(formatMessage(messages.requestMailSuccess));
              onCancel();//모달 닫기
            });

          }).catch(function(error) {
            console.log(error);
            message.error(formatMessage(messages.requestMailError));
            this.setState({loading: false});
            onCancel();
          });
        }

      }else{
        this.setState({loading: false})
      }

    })//validateFields end
  }//_handleRequest end

}//end class
  
Korea=Form.create({})(injectIntl(Korea));



export default Korea;
